module.exports = __webpack_public_path__ + "static/img/6_1.031f494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/6_1.png
// module id = Tuez
// module chunks = 0